if (!customElements.get('product-sticky-add-to-cart')) {
  customElements.define(
    'product-sticky-add-to-cart',
    class extends HTMLElement {
      connectedCallback() {
        const formId = this.getAttribute('form-id');
        if (!formId) return;

        const sectionId = formId.replace('product-form-', '');
        this.mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
        // Fallback: observe the form buttons container if submit button not found (e.g. force_in_stock)
        this.observeTarget = this.mainButton || document.getElementById(`button-form-${sectionId}`);
        if (!this.observeTarget) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle('is-visible', !entry.isIntersecting);
          },
          { threshold: 0 }
        );
        this.observer.observe(this.observeTarget);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }
  );
}
